import React from 'react';
import styled from 'styled-components';
import GocashIconSvg from '../assets/hotels/home/gocash.svg';

const GocashOfferIcon = styled(GocashIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  fill: ${props => props.theme.colors.goYellow.base};
  width: 1.4rem;
  height: 1.4rem;
`;

export default GocashOfferIcon;
